import React from "react";
import { InView } from 'react-intersection-observer';

import sepidSabt from "../images/portfolio/sepid-sabt.jpg";
import sanazafshari from "../images/portfolio/sanazafshari.jpg";
import enriskconsulting from "../images/portfolio/enriskconsulting.jpg";
import samran from "../images/portfolio/samran.jpg";


const Portfolio = () =>{
    const workItems=[
        {
            title:"www.enriskconsulting.com",
            thumbnail:enriskconsulting,
            description:"Company Website (Wordpress website)",
            link:"https://enriskconsulting.com"
        },
        {
            title:"www.sepid-sabt.ir",
            thumbnail:sepidSabt,
            description:"Company Website (Wordpress website)",
            link:"https://sepid-sabt.ir"
        },
        {
            title:"www.sanazafshari.com",
            thumbnail:sanazafshari,
            description:"Artist personal website (Wordpress website)",
            link:"http://sanazafshari.com"
        },{
            title:"www.samran.ir",
            thumbnail:samran,
            description:"Artist personal website (Wordpress website)",
            link:"http://samran.ir"
        }
    ]
    return (
        <div className="portfolio-section" id="portfolio_section">
            <div className="section-padding text-center">
            <h4 className="section-title">Portfolio</h4>
                <div className="work-items-holder clearfix">
                    {workItems.map(item=><InView key={item.title} triggerOnce>
                        {({ inView, ref, entry }) => (
                            <div ref={ref} className={`work-item ${inView ?"visible":""}`} ><a target="_blank" href={item.link} className="work-item-link">
                            <img src={item.thumbnail} alt={item.title} className="work-thumbnail" />
                            <div className="work-item-text">
                                <h3 className="simple-title">{item.title}</h3>
                                <p className="workItem-description">{item.description}</p>
                            </div>
                        </a></div>
                        )}
                    </InView>)}
                </div>
            </div>
        </div>
    )
}

export default Portfolio;